import { z } from 'zod'

export const currentExpensesDataSchema = z.object({
  total: z.number(),
  categories: z.array(
    z.object({
      // either a real category uuid or the literal `'uncategorized'` sentinel
      // used for shared-expense leftovers where the viewer cannot see the
      // per-split category.
      id: z.string(),
      name: z.string(),
      color: z.string().nullable(),
      icon: z.string().nullable(),
      total: z.number(),
    })
  ),
  expenses: z.array(
    z.object({
      id: z.string(),
      description: z.string().nullable(),
      amount: z.number(),
      date: z.string(),
      category: z.object({
        // either a real category uuid or the literal `'uncategorized'` sentinel
        // used for shared-expense leftovers where the viewer cannot see the
        // per-split category.
        id: z.string(),
        name: z.string(),
        color: z.string().nullable(),
        icon: z.string().nullable(),
      }),
    })
  ),
})
export type CurrentExpensesDataDto = z.infer<typeof currentExpensesDataSchema>

export const currentIncomesDataSchema = z.object({
  total: z.number(),
  categories: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      color: z.string().nullable(),
      icon: z.string().nullable(),
      total: z.number(),
    })
  ),
  incomes: z.array(
    z.object({
      id: z.string(),
      description: z.string().nullable(),
      amount: z.number(),
      date: z.string(),
      category: z.object({
        id: z.string(),
        name: z.string(),
        color: z.string().nullable(),
        icon: z.string().nullable(),
      }),
    })
  ),
})
export type CurrentIncomesDataDto = z.infer<typeof currentIncomesDataSchema>

export const incomeExpenseChartDataSchema = z.object({
  months: z.array(
    z.object({
      month: z.string(),
      activeIncome: z.number(),
      passiveIncome: z.number(),
      expense: z.number(),
      projected: z.boolean(),
    })
  ),
})
export type IncomeExpenseChartDataDto = z.infer<typeof incomeExpenseChartDataSchema>

export const monthsLeftDataSchema = z.object({
  monthsLeft: z.number().nullable(),
  months: z.array(
    z.object({
      month: z.string(),
      income: z.number(),
      expense: z.number(),
      total: z.number().nullable(),
      projected: z.boolean(),
    })
  ),
})
export type MonthsLeftDataDto = z.infer<typeof monthsLeftDataSchema>

export const incomeExpenseTableDataSchema = z.object({
  avgDayIncome: z.number(),
  avgDayExpense: z.number(),
  totalIncome: z.number(),
  totalExpense: z.number(),
  cashflow: z.number(),
})
export type IncomeExpenseTableDataDto = z.infer<typeof incomeExpenseTableDataSchema>
